import { Color, SectionMessage, Text } from '@billy/design-system'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { SubscriptionPeriod } from '@modules-deprecated/app/organization/enums/subscriptionPeriod'
import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'

import { OrganizationMarket } from '../../../../../../../../types/organizationMarket'
import { resolveSubscriptionPlan } from '../../../../utils/resolveSubscriptionPlan'

interface SwitchPlanSectionMessageProps {
  currentPlan: SubscriptionPlan
  market: OrganizationMarket
  switchPlan: SubscriptionPlan
  switchPlanPeriod?: SubscriptionPeriod
  subscriptionExpiringDate: string
}

export const SwitchPlanSectionMessageComponent = ({
  currentPlan,
  market,
  switchPlan,
  switchPlanPeriod,
  subscriptionExpiringDate,
}: SwitchPlanSectionMessageProps) => {
  const { t } = useTranslation()

  const downgradeVariant = switchPlan === SubscriptionPlan.Basic ? 'warning' : 'info'
  const textColor = switchPlan === SubscriptionPlan.Basic ? Color.Yellow700 : Color.Lavender500
  const switchPlanText = useMemo(() => {
    if (currentPlan === switchPlan) {
      return 'organization_subscription.plan_switch.continue.text'
    }
    if (
      (currentPlan === SubscriptionPlan.Basic && switchPlan !== SubscriptionPlan.Basic) ||
      (currentPlan === SubscriptionPlan.Pro && switchPlan === SubscriptionPlan.Premium)
    ) {
      return 'organization_subscription.plan_switch.upgrade.text'
    }

    return 'organization_subscription.plan_switch.downgrade.text'
  }, [currentPlan, switchPlan])

  const periodSwitchText = useMemo(() => {
    if (switchPlanPeriod && switchPlanPeriod === SubscriptionPeriod.Monthly) {
      return `(${t('organization_subscription.monthly')})`
    }
    if (switchPlanPeriod && switchPlanPeriod === SubscriptionPeriod.Yearly) {
      return `(${t('organization_subscription.yearly')})`
    }
    return ''
  }, [switchPlanPeriod, t])

  const switchPlanName = useMemo(() => {
    const resolvedPlan = resolveSubscriptionPlan(switchPlan, market || undefined)

    return t(resolvedPlan.content.name)
  }, [market, switchPlan, t])

  return (
    <SectionMessage icon="circleAlert" closable={false} variant={downgradeVariant}>
      <Text as="span" color={textColor}>
        {t(switchPlanText, {
          plan: switchPlanName,
          period: periodSwitchText,
          formattedSubscriptionDowngradeDate: subscriptionExpiringDate || '',
        })}
      </Text>
    </SectionMessage>
  )
}
